const EventEmitter = require('node:events');
const GraphQLClient = require('./client');
const { install: installSubscribe } = require('./subscribe');

class NativeGraphqlClient extends GraphQLClient {
  constructor(endpoint, autoInit = true, options = {}) {
    super(endpoint, autoInit, options);
    installSubscribe(this);
  }

  _getSocketOptions() {
    return {};
  }

  _getEventImplementation() {
    return EventEmitter;
  }
}

module.exports = NativeGraphqlClient;
